export const CUSTOM_TEE_PRICE = 34.99;
